import React, { useState } from "react";
import EmployerSearch from "../../components/search/EmployerSearch";
import DropDown from "../../components/common/DropDown";
import { useSearchParams } from "react-router-dom";
import { isMobile } from "../../utils/Utils";
import { BiFilterAlt } from "react-icons/bi";
import DrawerCommon from "../common/DrawerCommon";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const Profession = [
  { value: "Non-HC", label: "Non-HC - Non Healthcare" },
  { value: "HC", label: "HC - Health Care" },
];

const Status = [
  { value: "Active", label: "Active" },
  { value: "InActive", label: "Inactive" },
];

const Employers = [
  { value: "", label: "All Employers" },
  { value: "private", label: "Private Employers" }
];

export default function EmployerFilter(
  {
    profession, 
    setProfession, 
    status, 
    setStatus, 
    val, 
    setVal, 
    privateEmployer,
    setPrivateEmployer
  }  
) {

  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const detectMobile = isMobile();

  const { RangePicker } = DatePicker;
  const handleDateChange = (dates) => {
    if (!(!dates || !dates[0] || !dates[1])) {
      let startDate = dayjs(dates[0].$d).format("MM-DD-YYYY");
      let endDate = dayjs(dates[1].$d).format("MM-DD-YYYY");
      searchParams.set("StartDate", startDate);
      searchParams.set("EndDate", endDate);
      searchParams.set("page", 1);
      setSearchParams(searchParams);
    }
    else {
      searchParams.delete("StartDate");
      searchParams.delete("EndDate");
      setSearchParams(searchParams);
    }
  };


  const handleReset = () => {
    searchParams.delete("Professioncode");
    searchParams.delete("Status");
    searchParams.delete("private");
    searchParams.delete("PvtEmpIds");
    searchParams.delete("search");
    searchParams.set("page", 1);
    setVal("search");
    setSearchParams(searchParams);
    setProfession("Professions");
    setStatus("Status");
    setPrivateEmployer("All Employers");
  }

  const handleChange = (type, value) => {
    switch (type) {

      case "profession":
        setProfession(value);
        searchParams.set("Professioncode", value);
        searchParams.set("page", 1);
        setSearchParams(searchParams);
        break;

      case "status":
        setStatus(value);
        searchParams.set("Status", value);
        searchParams.set("page", 1);
        setSearchParams(searchParams);
        break;

      case "private":
        setPrivateEmployer(value);
        searchParams.set("private", value);
        searchParams.set("page", 1);
        setSearchParams(searchParams);
        break;

      default:
        break;
    }

  };

  return (
    <div className="SearchAndFilterContainer">
      <div className="SearchFilterContainer">
        <EmployerSearch val={val} setVal={setVal} />
      </div>
      {!detectMobile ? <> <div className="DropdownFilterContainer">
        <DropDown
          options={Profession}
          defaultValue={"Professions"}
          width={120}
          handleSelect={handleChange}
          name={"profession"}
          value={profession}
        />
      </div>
        <div className="DropdownFilterContainer">
          <DropDown
            options={Status}
            defaultValue={"status"}
            width={120}
            handleSelect={handleChange}
            name={"status"}
            value={status}
          />
        </div>
        <div className="DropdownFilterContainer">
          <DropDown
            options={Employers}
            defaultValue={"All Employers"}
            width={120}
            handleSelect={handleChange}
            name={"private"}
            value={privateEmployer}
          />
        </div>
        <span onClick={handleReset}>Clear Filter</span>
      </>
        : <><div className="mobile-filter-icon">
          <BiFilterAlt size={20} color="#007cf0" onClick={() => setOpen(true)} />
        </div>
          <DrawerCommon title="Filter" open={open} setOpen={setOpen} >
            <div className="DropdownFilterWrapper">
              <div className="search-header-Drower-Profession">Profession  </div>
              <div className="DropdownFilterContainer">
                <DropDown
                  options={Profession}
                  defaultValue={"Professions"}
                  handleSelect={handleChange}
                  name={"profession"}
                  value={profession}
                />
              </div>
              <div className="search-header-Drower-Profession">Status  </div>
              <div className="DropdownFilterContainer">
                <DropDown
                  options={Status}
                  defaultValue={"status"}
                  handleSelect={handleChange}
                  name={"status"}
                  value={status}
                />
              </div>
              <div className="search-header-Drower-Profession">Employer Type  </div>
              <div className="DropdownFilterContainer">
                <DropDown
                  options={Employers}
                  defaultValue={"All Employers"}
                  handleSelect={handleChange}
                  name={"private"}
                  value={privateEmployer}
                />
              </div>
              <div className="search-header-Drower-Profession">Date Range  </div>
              <div className="DropdownFilterContainer">
                <RangePicker
                  suffixIcon={false}
                  className="dateRangePicker"
                  onChange={handleDateChange}
                  format="MMM D, YYYY"
                />
              </div>
            </div>
            <span style={{ color: "#007cf0" }} onClick={handleReset}>Clear Filter</span>
          </DrawerCommon>
        </>}

    </div>
  );
}
